import { render, staticRenderFns } from "./ImagePickerItem.vue?vue&type=template&id=4e4a0195&"
import script from "./ImagePickerItem.vue?vue&type=script&lang=ts&"
export * from "./ImagePickerItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports